import { useSession } from '@/auth/useSession'
import { Status } from '@/components/common/Status'
import { BuildingIcon } from '@/components/common/icons'

/**
 * Shown when `useAccounts()` resolves to `[]` — the signed-in user has no
 * workspace memberships. The copy names the address we looked under, since
 * the usual cause is signing in with a personal address when the invite
 * went to a work one; the action signs them out so they can retry as
 * someone with memberships.
 */
export function EmptyState() {
  const { email, signout } = useSession()

  return (
    <Status
      icon={<BuildingIcon />}
      title="No workspaces yet"
      actions={
        <button
          type="button"
          className="btn"
          onClick={() => {
            void signout()
          }}
        >
          Use a different email
        </button>
      }
    >
      There are no Spaceti workspaces linked to{' '}
      <strong>{email ?? 'your account'}</strong> yet. If your team has already
      invited you, check a different email address.
    </Status>
  )
}
